<template>
	<div ref="notifications" class='notifications'>
		<div :key='notification.id' v-for="notification in notifications" class='d-flex flex-row-reverse'
			:ref='notification.key' :id='"notification-" + notification.key'>
            <div :class='"alert alert-" + notification.type + " alert-dismissible notification"'>
                <template v-if='notification.title'>
                    <h4>{{notification.title}}</h4>
                </template>
                <template v-if='notification.html'>
                    <div v-html='notification.content/*+ " [" + notification.key + "]"*/'></div>
                </template>
                <template v-else>
                    {{ notification.content /*+ " [" + notification.key + "]"*/ }}
                </template>
                <a v-if="notification.debug" v-on:click.prevent='showMoreInformation(notification.debug)' href="#">{{ $t('translations.link_more_information')}}</a>
                <template v-if="notification.route">
                    <router-link activeClass='' :to='notification.route.path' ><span v-on:click='checkRemove(notification)'>{{notification.route.text}}</span></router-link>
                </template>

                <div class='pt-2 d-flex flex-row-reverse' v-if="notification.dismissButton">
                    <button class='btn btn-light' v-on:click.prevent='notification.dismissButton(); removeNotification(notification.key)' href="#">{{ $t('translations.close')}}</button>
                </div>
                <a v-if="notification.dismissable" v-on:click.prevent='notification.dismissButton ? notification.dismissButton() : ""; removeNotification(notification.key)' href="#" class="close" aria-label="close">&times;</a>
            </div>
		</div>
	</div>
</template>

<script>
	/**
	 * Message types:
	 *
	 * success
	 * info
	 * warning
	 * danger
	 */

	export default {
		props: [
		],
		data: function(){
			return {
			};
		},
		computed: {
			notifications() {
				console.log("New notification");
				return this.$root.notifications;
			}
		},
		methods: {
            checkRemove(notification) {
                if(!notification.route_persist) {
                    this.removeNotification(notification.key);
                }
            },
			showMoreInformation(info) {
				this.$modal.show('dialog', {
					title: 'Debugging Information',
					text: "<p>Please copy and paste the content below and email to debug@redpixelyellowpixel.com</p><textarea style='height: 500px; width: 100%;'>" + info + "</textarea>",
					buttons: [
					{
						title: 'Okay',
						default: true
					}]},
					{
						scrollable: true,
						height: "auto",
						width: "100%"
					});
			}
		}
    }
</script>
